import React from 'react'
import { Box } from '@usap/uicomponents'
import { commaSeparetedValue } from '@usap/core'
import { SummaryDarkerItem } from '../SummaryWmo.css'

const ProductProtection = props => {
  const { data } = props

  return (
    <Box direction="row" justify="between">
      <SummaryDarkerItem>
        Product Protection:
      </SummaryDarkerItem>

      <SummaryDarkerItem data-testid='cart-summary-epp'>
        $
        {commaSeparetedValue(parseFloat(data?.warrantyProductTotal))}
      </SummaryDarkerItem>
    </Box>
  )
}

export default ProductProtection
